<template>
    <section id="steps-uid-6-p-0" role="tabpanel" aria-labelledby="steps-uid-6-h-0" class="body current" aria-hidden="false">
        <form @submit.prevent="validate">
            <div class="row">
                <div class="col-md-12">
                    <div class="form-group">
                        <label>Select Offer Contract Type</label>
                        <div class="form-check">
                            <input type="radio"
                                   id="FORWARD"
                                   name="contract_type"
                                   class="form-check-input"
                                   value="FORWARD"
                                   @click="setOfferContract"
                                   v-model="offer.contract_type"
                                   v-validate="'required'"
                                   :class="{'is-invalid': submitted && errors.has('contract_type')}"
                                   data-vv-as="contract_type">
                            <label class="form-check-label" for="FORWARD">Forward
                                <small>- A contract for buying/selling commodities at a future date at a price agreed upon today. <b>Requires Expiration and Maturation Date</b></small>
                            </label>
                        </div>
                        <div class="form-check">
                            <input type="radio"
                                   id="SPOT"
                                   name="contract_type"
                                   class="form-check-input"
                                   value="SPOT"
                                   @click="setOfferContract"
                                   v-model="offer.contract_type"
                                   v-validate="'required'"
                                   :class="{'is-invalid': submitted && errors.has('contract_type')}"
                                   data-vv-as="contract_type">
                            <label class="form-check-label" for="SPOT">Spot
                                <small>- A contract for buying/selling commodities for immediate settlement. <b>Does not require Expiration and Maturation Date</b></small>
                            </label>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <div class="form-group">
                        <label>Select Offer Type</label>
                        <div class="form-check">
                            <input type="radio"
                                   id="BUY"
                                   name="type"
                                   class="form-check-input"
                                   value="BUY"
                                   @click="setOfferType"
                                   v-model="offer.type"
                                   v-validate="'required'"
                                   :class="{'is-invalid': submitted && errors.has('type')}"
                                   data-vv-as="type">
                            <label class="form-check-label" for="BUY">Buy</label>
                        </div>
                        <div class="form-check">
                            <input type="radio"
                                   id="SELL"
                                   name="type"
                                   class="form-check-input"
                                   value="SELL"
                                   @click="setOfferType"
                                   v-model="offer.type"
                                   v-validate="'required'"
                                   :class="{'is-invalid': submitted && errors.has('type')}"
                                   data-vv-as="type">
                            <label class="form-check-label" for="SELL">Sell</label>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <div class="form-group">
                        <label>Select Offer Category</label>
                        <div class="form-check">
                            <input type="radio"
                                   id="FIRM"
                                   name="firm"
                                   class="form-check-input"
                                   value="FIRM"
                                   @click="setOfferCategory"
                                   v-model="offer.category"
                                   v-validate="'required'"
                                   :class="{'is-invalid': submitted && errors.has('firm')}"
                                   data-vv-as="category">
                            <label class="form-check-label" for="FIRM">Firm
                                <small> - an offer that will remain open for a certain time period or until the happening of a certain event, till which the offer cannot be revoked</small>
                            </label>
                        </div>
                        <div class="form-check">
                            <input type="radio"
                                   id="NEGOTIABLE"
                                   name="negotiable"
                                   class="form-check-input"
                                   value="NEGOTIABLE"
                                   @click="setOfferCategory"
                                   v-model="offer.category"
                                   v-validate="'required'"
                                   :class="{'is-invalid': submitted && errors.has('negotiable')}"
                                   data-vv-as="category">
                            <label class="form-check-label" for="NEGOTIABLE">Negotiable
                                <small> - allows users more flexibility and open communication, especially if you are willing to look at alternative movement periods or freight terms</small>
                            </label>
                        </div>
                        <div class="form-check">
                            <input type="radio"
                                   id="NOPRICE"
                                   name="noprice"
                                   class="form-check-input"
                                   value="NOPRICE"
                                   @click="setOfferCategory"
                                   v-model="offer.category"
                                   v-validate="'required'"
                                   :class="{'is-invalid': submitted && errors.has('noprice')}"
                                   data-vv-as="category">
                            <label class="form-check-label" for="NOPRICE">No price
                                <small> - allows users to sell/buy new or old crop commodities without setting a price.</small>
                            </label>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <div class="form-group" id="data_1">
                        <label for="expires_at">Offer Expiry Date</label>
                        <div class="input-group">
                            <div class="input-group-prepend date">
                                <span class="input-group-text"><i class="fa fa-calendar"></i></span>
                            </div>
                            <input type="text"
                                   class="form-control"
                                   id="expires_at"
                                   name="expires_at"
                                   placeholder="mm/dd/yyyy"
                                   v-model="offer.expires_at"
                                   v-validate="isForward ? 'required': ''"
                                   :class="{'is-invalid': submitted && errors.has('expires_at')}"
                                   data-vv-as="expires_at">
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <div class="form-group" id="data_2">
                        <label for="maturation_date">Offer Maturation Date</label>
                        <div class="input-group">
                            <div class="input-group-prepend date">
                                <span class="input-group-text"><i class="fa fa-calendar"></i></span>
                            </div>
                            <input type="text"
                                   class="form-control"
                                   id="maturation_date"
                                   name="maturation_date"
                                   placeholder="mm/dd/yyyy"
                                   v-model="offer.maturation_date"
                                   v-validate="isForward ? 'required':''"
                                   :class="{'is-invalid': submitted && errors.has('maturation_date')}"
                                   data-vv-as="expires_at">
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </section>
</template>

<script>
    export default {
        name: "AllOffers",
        mounted() {
            this.$nextTick(() => {
                this.init();
            })
        },
        data() {
            return {
                submitted: false,
                isForward: false,
                offer: this.$parent.offer
            }
        },
        methods: {
            init() {
                jQuery('#expires_at').datepicker({
                    autoclose: true,
                    todayHighlight: true
                }).on('change', (event) => {
                    this.offer.expires_at = event.target.value;
                });

                jQuery('#maturation_date').datepicker({
                    autoclose: true,
                    todayHighlight: true
                }).on('change', (event) => {
                    this.offer.maturation_date = event.target.value;
                });
            },
            setOfferContract(event) {
                this.offer.contract_type = event.target.value;
                this.isForward           = this.offer.contract_type === 'FORWARD';
            },
            setOfferType(event) {
                this.offer.type = event.target.value;
            },
            setOfferCategory(event) {
                this.offer.category = event.target.value;
            },
            async validate() {
                this.submitted = true;
                let valid      = await this.$validator.validate();
                return valid;
            }
        }
    }
</script>

<style scoped>

</style>
